import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-lg font-semibold text-foreground-100 whitespace-nowrap hover:text-primary-500 transition-colors">
              自拍指南
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              探索亚洲自拍的完整世界，从拍摄技巧到设备推荐，为你提供最全面的实用指南。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              内容分类
            </h4>
            <div className="space-y-2">
              <Link to="/category/shooting-tips" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                拍摄技巧
              </Link>
              <Link to="/category/filter-styles" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                滤镜与风格
              </Link>
              <Link to="/category/equipment-lighting" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                设备与灯光
              </Link>
              <Link to="/category/beauty-selfie" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                美妆自拍
              </Link>
              <Link to="/category/influencer-style" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                网红风格
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              关于我们
            </h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                用户口碑
              </Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
                联系我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-booklet-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 亚洲自拍完全指南. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}